import { defineNuxtPlugin } from '#app'
import { getCompatFeatures, resolveCompatLevel } from '@/utils/compatMode'

export default defineNuxtPlugin((nuxtApp) => {
  try {
    const level = resolveCompatLevel()
    const features = getCompatFeatures(level)

    if (typeof document !== 'undefined' && features.isActive) {
      document.documentElement.setAttribute('data-compat-level', String(features.level))
      const style = document.createElement('style')
      style.setAttribute('data-compat-style', 'true')
      style.textContent =
        'html,body{background:#0f172a!important;color:#e2e8f0!important}#__nuxt{min-height:100vh}'
      document.head.appendChild(style)
    }

    const captureError = (msg: string) => {
      ;(window as Window & { __MOJI_COMPAT_ERROR__?: string }).__MOJI_COMPAT_ERROR__ = msg
      const el = document.getElementById('compat-early-boot')
      if (el) {
        el.textContent = `JS 错误: ${msg.slice(0, 200)}`
        el.style.background = '#7f1d1d'
      }
    }

    if (features.isActive) {
      window.addEventListener('error', (e) => {
        captureError(e.message || String(e.error))
      })
      window.addEventListener('unhandledrejection', (e) => {
        captureError(String(e.reason))
      })

      nuxtApp.hook('app:mounted', () => {
        const el = document.getElementById('compat-early-boot')
        if (el) el.style.display = 'none'
      })
    }

    return {
      provide: {
        compatLevel: level,
        compatFeatures: features,
      },
    }
  } catch (e) {
    console.warn('[compat-mode] plugin failed safe:', e)
    const features = getCompatFeatures(null)
    return {
      provide: {
        compatLevel: null,
        compatFeatures: features,
      },
    }
  }
})
